<template>
  <div class="appFoot">
    <router-link replace to="/" :class="{ on: currentRoute === 'home' }">
      <i class="icon icon-home"></i>
      <span>首页</span>
    </router-link>
    <router-link replace to="/category" :class="{ on: currentRoute === 'category' }">
      <i class="icon icon-apps"></i>
      <span>搜索</span>
    </router-link>
    <!-- <router-link replace to="/lives" :class="{ on: currentRoute === 'lives' }">
      <i class="icon icon-a-zu542"></i>
      <span>一起看</span>
    </router-link> -->
    <router-link replace to="/more" :class="{ on: currentRoute === 'more' }">
      <i class="icon icon-more"></i>
      <span>我的</span>
    </router-link>
  </div>
</template>
<script>
export default {
  computed: {
    currentRoute() {
      return this.$route.name
    }
  }
}
</script>
<style scoped lang='scss'>
.appFoot {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: $app-foot-height;
  display: flex;
  background-color: $color-white;
  border-top: $style-border;

  a {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    color: $thirdly-text-color;

    &.on {
      color: $color-red;
    }

    i {
      font-size: 24px;
    }

    span {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// AppFoot.vue?f314e5cc